import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Divider, Menu, MenuProps, message, Modal } from "antd";
import { getOpenKeys } from "@/utils/util";
import ADList from "@/pages/Admenergement"

import { useDispatch } from "react-redux";
import { ExclamationCircleOutlined, BarChartOutlined } from "@ant-design/icons";
import Logo from "./components/logo";
import Team from "./components/Team";

import "./index.less";
import MenuIcon from "@/routers/menu_icon";
import logoutIcon from "@/assets/icons/menu/登出.png";
import homeIcon from "@/assets/icons/menu/首页.png";
import accountIcon from "@/assets/icons/menu/账户.png";
import ruleIcon from "@/assets/icons/menu/规则.png";
import adIcon from "@/assets/icons/menu/广告管理.png";
import assetIcon from "@/assets/icons/menu/资产.png";
import { useTranslation } from "react-i18next";
import { setToken } from "@/redux/modules/global/action";

type MenuItem = Required<MenuProps>["items"][number];

const LayoutMenu = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const [openKeys, setOpenKeys] = useState<string[]>([]);
	const [selectedKeys, setSelectedKeys] = useState<string[]>([pathname]);

	// 刷新页面菜单保持高亮
	useEffect(() => {
		setOpenKeys(getOpenKeys(pathname));
		setSelectedKeys([pathname]);
	}, [pathname]);

	let menu = [
		{
			label: t("menu.home"),
			key: "/home/index",
			icon: <MenuIcon src={homeIcon} />
		} as MenuItem,
		{
			label: t("menu.account"),
			key: "/account/index",
			icon: <MenuIcon src={accountIcon} />
		} as MenuItem,
		{
			label: t("menu.automatedRules"),
			key: "/Automated",
			icon: <MenuIcon src={ruleIcon} />,
			children: [
				{
					label: t("menu.automatedRules.manageRules"),
					key: "/Automated/manage"
				} as MenuItem,
				{
					label: t("menu.automatedRules.rulesMarket"),
					key: "/Automated/market"
				} as MenuItem,
				{
					label: t("menu.automatedRules.actionHistory"),
					key: "/Automated/log"
				} as MenuItem
			]
		},
		{
			label:'广告管理',
			key:'/ad',
			icon: <MenuIcon src={adIcon}/>,
			children: [
				{
					label:"广告管理",
					key:'/ad/adlist',
				}
			]
		},
		{
			label:'数据概览',
			key:'/data',
			icon: <BarChartOutlined style={{ fontSize: '16px' }} />,
			children: [
				{
					label:"数据概览",
					key:'/data/analysis',
				}
			]
		}
	];

	const onOpenChange = (openKeys: string[]) => {
		if (openKeys.length === 0 || openKeys.length === 1) return setOpenKeys(openKeys);
		const latestOpenKey = openKeys[openKeys.length - 1];
		if (latestOpenKey.includes(openKeys[0])) return setOpenKeys(openKeys);
		setOpenKeys([latestOpenKey]);
	};

	// 点击当前菜单跳转页面
	const clickMenu: MenuProps["onClick"] = ({ key }: { key: string }) => {
		navigate(key);
	};

	const logout = () => {
		Modal.confirm({
			icon: <ExclamationCircleOutlined />,
			title: t("menu.logout"),
			content: t("menu.logout.confirm.content"),
			onOk: () => {
				dispatch(setToken(""));
				localStorage.removeItem("nickname");
				localStorage.removeItem("token");

				message.success("Log out successfully");
				navigate("/login");
			}
		});
	};

	return (
		<div className="menu">
			<Logo />
			<Menu
				items={menu}
				mode="inline"
				triggerSubMenuAction="click"
				openKeys={openKeys}
				selectedKeys={selectedKeys}
				onOpenChange={onOpenChange}
				onClick={clickMenu}
			/>
			<div className="menu_bottom">
				<Divider style={{ marginBottom: "1rem" }} />
				<Team />
				<Button
					style={{
						height: "40px",
						padding: 0,
						border: "none",
						textAlign: "left"
					}}
					onClick={() => {
						logout();
					}}
				>
					<MenuIcon src={logoutIcon} />
					<span style={{ color: "#707793", fontSize: "14px", lineHeight: "20px" }}>{t("menu.logout")}</span>
				</Button>
			</div>
		</div>
	);
};

export default LayoutMenu;
